import { Plane, useVideoTexture } from '@react-three/drei';
import { useSelector } from 'react-redux';
import * as THREE from 'three';

export const VideoTexture = ({ src = '/assets/videos/intro-video.mp4' }) => {
  const { worldParams } = useSelector((state) => state);
  const texture = useVideoTexture(src, {
    loop: true,
    muted: true,
    autoplay: true,
    crossOrigin: 'Anonymous',
    playsInline: true,
  });

  const { sceneId } = worldParams;

  if (sceneId !== '691c21599d4e2e854cda4544') {
    return null;
  }

  return (
    <Plane
      args={[10, 5]}
      position={[400, -2, -150]}
      rotation={[0, Math.PI / 1.23, 0]}
      scale={[42, 36, 1]}
    >
      <meshBasicMaterial side={THREE.DoubleSide} map={texture} />
    </Plane>
  );
};
